<a
  [href]="'/' + accomodation.slug"
  class="wrapper"
  [style.background-image]="articleImageSrc"
  appSpot
  text="Découvrir"
  icon="/icons/seeMore.svg"
  backgroundColor="#D17A2A"
  appRatio
  [x]="ratioX"
  [y]="ratioY"
  appZoom
  [picture]="accomodation.coverPicture"
  #wrapper
>
  <div class="article-title w-10">
    @if(accomodation.place){
    <div class="destination">
      <p class="upper">
        {{ accomodation.place }}, <em>{{ accomodation.destination?.country }}</em>
      </p>
    </div>
    }
    <h2>{{ accomodation.name }}</h2>
  </div>
</a>
